
import { useMutation } from 'react-query';
import { ResetPasswordEmailFormData, model } from "..";

export const useSendResetEmail = () => useMutation((data: ResetPasswordEmailFormData) => model.sendResetEmail(data));
